import PropTypes from "prop-types";
import Chip from "@mui/material/Chip";
import SuiBox from "components/SuiBox";

// Same tones as GoalStatusChip / GoalPill.
const TONES = {
  info: { text: "#0b7c99", bg: "#e0f5fb", border: "#17c1e8" },
  success: { text: "#0e7a2b", bg: "#e4f6e8", border: "#17ad37" },
  warning: { text: "#946200", bg: "#fff4d6", border: "#f2b705" },
  error: { text: "#c01616", bg: "#fde7e7", border: "#ea0606" },
  secondary: { text: "#4b5a73", bg: "#eef0f4", border: "#8392ab" },
};

// "All 3 · WFH approved 1 · Remote 1 · No approval 1": narrows the table to one
// approval status. The selected chip is filled in its colour.
function ApprovalChips({ chips, value, onChange }) {
  return (
    <SuiBox display="flex" flexWrap="wrap" gap={1} px={3} pb={2}>
      {chips.map((chip) => {
        const tone = TONES[chip.color] || TONES.secondary;
        const selected = chip.value === value;
        return (
          <Chip
            key={chip.value || "all"}
            clickable
            size="small"
            onClick={() => onChange(chip.value)}
            label={
              <>
                {chip.label} <strong>{chip.count}</strong>
              </>
            }
            sx={{
              height: 26,
              borderRadius: "13px",
              fontSize: 12,
              fontWeight: selected ? 700 : 500,
              color: selected ? tone.text : "#4b5a73",
              backgroundColor: selected ? tone.bg : "transparent",
              border: `1px solid ${selected ? tone.border : "#dde1e8"}`,
              "&:hover": { backgroundColor: tone.bg },
              "& .MuiChip-label": { px: 1.5 },
            }}
          />
        );
      })}
    </SuiBox>
  );
}

ApprovalChips.propTypes = {
  chips: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      count: PropTypes.number.isRequired,
      color: PropTypes.string,
    })
  ).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ApprovalChips;
